import { render } from "./Blockly.vue?vue&type=template&id=5e9e34fe"
import script from "./Blockly.vue?vue&type=script&lang=js"
export * from "./Blockly.vue?vue&type=script&lang=js"

import "./Blockly.vue?vue&type=style&index=0&id=5e9e34fe&lang=postcss"
script.render = render

export default script